import { templateThemeTokens } from './templateThemeTokens.js';
import { fontStacks } from '@/stitches/fonts.js';
import { createTheme } from '@/stitches/index.js';
import { merge } from 'lodash-es';

const mergedTokens = merge(templateThemeTokens, {
  colors: {
    defaultFont: '#046DB4',
    pageBackground: '#fffaf4',
  },
  fonts: {
    body: fontStacks.switzer.value,
    heading: fontStacks.butler.value,
  },
});

export const morning = createTheme({ ...mergedTokens });
